/* eslint-disable no-lonely-if */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-plusplus */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import { useCallback, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import Center from '../../assets/styles/Center';
import EditContainer from '../../assets/styles/EditContainer';
import Text from '../../assets/styles/Text';
import Loader from '../../components/Loader';
import FiltersService from '../../services/FiltersService';
import ModelService from '../../services/ModelService';
import { useStore } from '../../stores';
import * as styles from './styles';

export default function ModelFilter() {
  const [loading, setLoading] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [filters, setFilters] = useState([]);
  const [selectedValues, setSelectedValues] = useState({});
  const [savedFilters, setSavedFilters] = useState([]);

  const { id } = useStore((state) => state.user);

  // Parse choices
  const parseChoices = useCallback((choicesString) => {
    if (!choicesString) return [];
    return choicesString
      .split(',')
      .map((choice) => choice.trim())
      .filter(Boolean);
  }, []);

  useEffect(() => {
    async function loadData() {
      try {
        setLoading(true);

        const modelData = await ModelService.findById(id);

        const filtersService = await FiltersService.listFiltersGender(
          modelData.gender
        );
        const modelFilters = await FiltersService.getModelFilters();

        setFilters(filtersService || []);
        setSavedFilters(modelFilters || []);

        if (modelFilters && modelFilters.length > 0) {
          const savedValues = {};
          modelFilters.forEach((filter) => {
            savedValues[filter.filterId] = filter.content;
          });
          setSelectedValues(savedValues);
        }
      } catch (error) {
        console.error('Erro ao carregar filtros:', error);
        toast.error('Erro ao carregar filtros');
      } finally {
        setLoading(false);
      }
    }

    loadData();
  }, [id]);

  // Organizar filtros em duas colunas
  const organizeFiltersInColumns = useCallback(() => {
    if (!Array.isArray(filters) || filters.length === 0) {
      return { leftColumn: [], rightColumn: [] };
    }

    const rootFilters = filters.filter((filter) => !filter.parentId);
    const middle = Math.ceil(rootFilters.length / 2);

    const leftColumn = rootFilters.slice(0, middle).map((filter) => ({
      ...filter,
      children: filters.filter((f) => f.parentId === filter.id),
    }));

    const rightColumn = rootFilters.slice(middle).map((filter) => ({
      ...filter,
      children: filters.filter((f) => f.parentId === filter.id),
    }));

    return { leftColumn, rightColumn };
  }, [filters]);

  // Toggle filtro
  const handleToggle = useCallback((filterId, choice = null) => {
    setSelectedValues((prev) => {
      const newValues = { ...prev };
      // const key = choice ? `${filterId}-${choice}` : filterId;

      if (choice) {
        // Para filtros com choices
        if (newValues[filterId] === choice) {
          delete newValues[filterId];
        } else {
          newValues[filterId] = choice;
        }
      } else {
        // Para filtros boolean
        if (newValues[filterId] === true) {
          delete newValues[filterId];
        } else {
          newValues[filterId] = true;
        }
      }

      return newValues;
    });
  }, []);

  // Salvar filtros
  const onSubmit = useCallback(async () => {
    try {
      setLoadingSubmit(true);

      const changes = [];

      filters.forEach((filter) => {
        const currentValue = selectedValues[filter.id];
        const savedFilter = savedFilters.find(
          (sf) => sf.filterId === filter.id
        );
        const savedValue = savedFilter?.content;

        if (currentValue !== savedValue) {
          if (currentValue !== undefined) {
            changes.push({
              filterId: filter.id,
              content: currentValue,
              action: 'save',
            });
          } else if (savedFilter) {
            changes.push({
              filterId: filter.id,
              action: 'delete',
            });
          }
        }
      });

      if (changes.length === 0) {
        toast.success('Nenhuma alteração para salvar');
        return;
      }

      let successCount = 0;
      let errorCount = 0;

      for (const change of changes) {
        try {
          if (change.action === 'save') {
            await FiltersService.upsertModelFilter({
              filterId: change.filterId,
              content: change.content,
            });
          } else if (change.action === 'delete') {
            await FiltersService.deleteModelFilter(change.filterId);
          }
          successCount++;
        } catch (error) {
          console.error('Erro ao processar mudança:', error);
          errorCount++;
        }
      }

      if (successCount > 0) {
        toast.success(`${successCount} alteração(ões) salva(s)!`);

        const updatedFilters = await FiltersService.getModelFilters();
        setSavedFilters(updatedFilters || []);

        const newSelectedValues = {};
        updatedFilters.forEach((filter) => {
          newSelectedValues[filter.filterId] = filter.content;
        });
        setSelectedValues(newSelectedValues);
      }

      if (errorCount > 0) {
        toast.error(`${errorCount} erro(s) ao salvar filtros`);
      }
    } catch (error) {
      console.error('Erro geral no submit:', error);
      toast.error('Erro ao salvar filtros');
    } finally {
      setLoadingSubmit(false);
    }
  }, [filters, selectedValues, savedFilters]);

  // Renderizar filtro
  const renderFilter = useCallback(
    (filter) => {
      const choices = parseChoices(filter.choices);
      const hasChildren = filter.children && filter.children.length > 0;

      // Se tem filhos (ex: Corpo → Magra, Plus Size, Atlético)
      if (hasChildren) {
        const allOptions = [filter, ...filter.children];

        return (
          <styles.FilterGroup key={filter.id}>
            <Text.Span>{filter.name}</Text.Span>
            <styles.ChoicesGrid>
              {allOptions.map((option) => {
                const isActive = selectedValues[option.id] !== undefined;

                return (
                  <styles.ChoiceButton
                    key={option.id}
                    type="button"
                    $isActive={isActive}
                    onClick={() => {
                      // Limpar outros do mesmo grupo
                      allOptions.forEach((opt) => {
                        if (
                          opt.id !== option.id &&
                          selectedValues[opt.id] !== undefined
                        ) {
                          handleToggle(opt.id);
                        }
                      });
                      handleToggle(option.id);
                    }}
                  >
                    {option.name}
                  </styles.ChoiceButton>
                );
              })}
            </styles.ChoicesGrid>

            <styles.FilterDivider />
          </styles.FilterGroup>
        );
      }

      // Se tem choices (ex: Cabelo → Curto, Longo)
      if (choices.length > 0) {
        return (
          <styles.FilterGroup key={filter.id}>
            <Text.Span>{filter.name}</Text.Span>
            <styles.ChoicesGrid>
              {choices.map((choice) => {
                const isActive = selectedValues[filter.id] === choice;

                return (
                  <styles.ChoiceButton
                    key={choice}
                    type="button"
                    $isActive={isActive}
                    onClick={() => handleToggle(filter.id, choice)}
                  >
                    {choice}
                  </styles.ChoiceButton>
                );
              })}
            </styles.ChoicesGrid>

            <styles.FilterDivider />
          </styles.FilterGroup>
        );
      }

      // Se não tem choices, renderizar como boolean (Sim/Não)
      const isActive = selectedValues[filter.id] === true;

      return (
        <styles.FilterGroup key={filter.id}>
          <Text.Span>{filter.name}</Text.Span>
          <styles.ChoicesGrid>
            <styles.ChoiceButton
              type="button"
              $isActive={isActive}
              onClick={() => handleToggle(filter.id)}
            >
              Sim
            </styles.ChoiceButton>
            <styles.ChoiceButton
              type="button"
              $isActive={isActive === false}
              onClick={() => handleToggle(filter.id)}
            >
              Não
            </styles.ChoiceButton>
          </styles.ChoicesGrid>

          <styles.FilterDivider />
        </styles.FilterGroup>
      );
    },
    [selectedValues, parseChoices, handleToggle]
  );

  const { leftColumn, rightColumn } = organizeFiltersInColumns();

  if (loading) return <Loader isLoading={loading} />;

  return (
    <EditContainer>
      <Center className="center">
        <styles.Container>
          <styles.Header>
            <Text.H1 $upper>Informações sobre você</Text.H1>
          </styles.Header>

          <styles.Row>
            <styles.Column>
              {leftColumn.map((filter) => renderFilter(filter))}
            </styles.Column>

            <styles.VerticalDivider />

            <styles.Column>
              {rightColumn.map((filter) => renderFilter(filter))}
            </styles.Column>
          </styles.Row>

          {filters?.length === 0 && !loading && (
            <styles.Empty>
              <h2>Nenhum filtro disponível para o seu perfil.</h2>
            </styles.Empty>
          )}

          <styles.SubmitButton
            type="button"
            onClick={onSubmit}
            disabled={loadingSubmit}
          >
            {loadingSubmit ? 'Salvando...' : 'SALVAR FILTROS'}
          </styles.SubmitButton>
        </styles.Container>
      </Center>
    </EditContainer>
  );
}
